import Footer from "./components/SunTimesUI/Footer/Footer";
import GoogleAd from "./components/SunTimesUI/GoogleAd/GoogleAd";
import React, { useState, useEffect } from "react";
import SunTimesHeader from "./components/SunTimesUI/SunTimesHeader/SunTimesHeader";
import * as d3 from "d3";
import styles from "./App.module.css";
import { year, parse_time, filterBy, getCurrentYear } from "./helperFunctions";
import HeaderGraphic from "./components/HeaderGraphic/HeaderGraphic";
import RankTable from "./components/RankTable/RankTable";
import CommunityAreaProfile from "./components/CommunityAreaProfile/CommunityAreaProfiles";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import DemographicsBarChart from "./components/DemographicsBarChart/DemographicsBarChart";
import priority_communities from "./data/priority-communities-list.json";
import Loading from "./components/Loading/Loading";

const priority_communities_names = priority_communities.map((d) => d.name);

function App() {
  const [data, setData] = useState(null);

  async function fetchShootingData() {
    fetch(
      "https://graphics.suntimes.com/data-storage/violence-data/tmp/violence.json"
    )
      .then((response) => response.json())
      .then((data) => {
        const priorityData = Array.from(
          d3.rollup(
            data.filter(
              (d) =>
                parse_time(d.DATE).getFullYear() > 2017 &&
                priority_communities_names.includes(
                  d.COMMUNITY_AREA.toLowerCase()
                )
            ),
            (v) => {
              return {
                population: priority_communities.filter(
                  (o) => o.name === v[0].COMMUNITY_AREA.toLowerCase()
                )[0].pop,
                victimizations: v.filter((d) => filterBy.victimizations(d)),
                homicides: v.filter((d) => filterBy.homicides(d)),
                shootings: v.filter((d) => filterBy.nonFatalShootings(d)),
              };
            },
            (d) => d.COMMUNITY_AREA.toString()
          )
        );

        const updated = data.sort((a, b) =>
          parse_time(a.DATE) < parse_time(b.DATE) ? 1 : -1
        )[0].DATE;

        const testUpdated = "1/31/2021 12:00:00 am";
        const currentYearData = getCurrentYear(
          data.filter((d) =>
            priority_communities_names.includes(d.COMMUNITY_AREA.toLowerCase())
          ),
          testUpdated
        );
        return setData({
          updated: testUpdated,
          victimizations: currentYearData.filter((d) =>
            filterBy.victimizations(d)
          ).length,
          homicides: currentYearData.filter((d) => filterBy.homicides(d))
            .length,
          nonFatalShootings: currentYearData.filter((d) =>
            filterBy.nonFatalShootings(d)
          ).length,
          priorityCommunities: priorityData,
        });
      });
  }

  useEffect(() => fetchShootingData(), []);

  function handleScrollTo(neighborhood) {
    window.scrollTo({
      top: findPos(document.getElementById(neighborhood)),
    });
    function findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        do {
          curtop += obj.offsetTop - 8;
        } while ((obj = obj.offsetParent));
        return [curtop];
      }
    }
  }

  if (data) {
    return (
      <div>
        <SunTimesHeader />
        <GoogleAd />
        <h1>How Chicago's most violent neighborhoods are faring</h1>
        <div className={styles.Byline}>
          <p>
            <span>By</span>{" "}
            <a href="https://chicago.suntimes.com/authors/jesse-howe">
              Jesse Howe
            </a>{" "}
            and{" "}
            <a href="https://chicago.suntimes.com/authors/andy-boyle">
              Andy Boyle
            </a>
          </p>
          <p className={styles.Updated}>
            Data updated {d3.timeFormat("%b. %d, %Y")(parse_time(data.updated))}
          </p>
        </div>
        <div className={styles.Share}>
          <a
            className={styles.Facebook}
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/sharer/sharer.php?u=https://graphics.suntimes.com/priority-communities/"
          >
            <FacebookIcon />
          </a>
          <a
            className={styles.Twitter}
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/intent/tweet?url=https://graphics.suntimes.com/priority-communities/&text=Explore%20Chicago%20priority%20communities%20and%20see%20which%20are%20on%20track%20to%20be%20deadlier%20or%20less%20deadly%20than%20previous%20years."
          >
            <TwitterIcon />
          </a>
        </div>
        <p className={styles.Note}>
          Updated tracker coming late this summer 2023
        </p>
        {/* <div className={styles.StoryDesc}>
          <div className={styles.SeriousVictimizationDesc}>
            <p>
              Note: Serious victimizations are defined as somebody shot or
              killed.
            </p>
          </div>
          <p>
            At least <strong>{d3.format(",")(data.victimizations)}</strong>{" "}
            serious victimizations have been reported since the beginning of{" "}
            <strong>{year}</strong> in the 15 priority community areas of
            Chicago, accoriding to a Sun-Times analysis of Chicago's
            victimization data. As of{" "}
            {d3.timeFormat("%b. %e")(parse_time(data.updated))} these
            victimizations consist of{" "}
            <strong>{d3.format(",")(data.homicides)}</strong> homicides and{" "}
            <strong>{d3.format(",")(data.nonFatalShootings)}</strong> non-fatal
            shootings.
          </p>
        </div> */}
        {/* <HeaderGraphic
          data={data.priorityCommunities}
          updated={data.updated}
          handleScrollTo={(d) => handleScrollTo(d)}
        /> */}
        {/* <div className={styles.StoryDesc}>
          <p>
            The 15 priority neighborhoods are at a higher risk of violence than
            the general population of Chicago. Between 2018 and 2020 these
            community areas experienced nearly 64% of the serious victimizations
            in Chicago despite only making up 30% of the population.
          </p>
          <p>
            In September 2020, the mayor’s office published{" "}
            <a href="https://www.chicago.gov/city/en/sites/public-safety-and-violence-reduction/home/our-city-our-safety.html">
              Our City, Our Safety
            </a>
            , an ambitious plan to drastically reduce violence in Chicago’s
            worst neighborhoods through 2023. It focuses resources on 15
            community areas that account for about 50 percent of the serious
            victimizations in the city. Below is an analysis of where those
            communities are so far, based on a Sun-Times analysis of census data
            and{" "}
            <a href="https://data.cityofchicago.org/Public-Safety/Violence-Reduction-Victims-of-Homicides-and-Non-Fa/gumc-mgzr/data">
              Chicago police victimization data
            </a>
            .
          </p>
          <p>
            The priority community areas are primarily concentrated in Chicago’s
            west and south sides where violence primarily affects communities of
            color and lower incomes.
          </p>
          <DemographicsBarChart />
          <p>
            The Sun-Times victimization numbers are based on the city’s own
            victimization data portal. The dataset is refreshed daily, but
            excludes the most recent 48 hours. The totals shown here almost
            certainly represent an undercount of the true toll.
          </p>
          <p>
            Although the city has chosen to rank the priority community areas
            based on their total serious victimizations, the Sun-Times has
            decided to keep a dynamic list based on the current rate of
            victimizations per 10,000 residents and rank the community areas on
            the gap between the current year’s per capita victimization rate and
            the previous year categorizing neighborhoods as more violent, less
            violent, or the same.
          </p>
          <p>
            Priority community areas are also compared against their 2018-2020
            three year averages as the spike in victimizations during this
            period in time spurred the formation of the priority community areas
            and is used as a second metric to measure improvement.
          </p>
          <p>
            You can help fund this journalism by{" "}
            <a href="https://chicago.suntimes.com/pages/subscribe?tpcc=homicide-page&_ga=2.222512735.514583729.1640624982-819784054.1616433115">
              subscribing
            </a>{" "}
            to the Chicago Sun-Times today.
          </p>
        </div> */}
        {/* <RankTable
          data={data.priorityCommunities}
          updated={data.updated}
          handleScrollTo={(d) => handleScrollTo(d)}
        /> */}
        {/* <GoogleAd /> */}
        {/* <CommunityAreaProfile
          data={data.priorityCommunities}
          updated={data.updated}
        /> */}
        {/* <GoogleAd /> */}
        <Footer />
      </div>
    );
  } else {
    return <Loading />;
  }
}

export default App;
